'use client';
import React, { useState, useEffect } from 'react';

const announcements = [
  'Custom Packaging for Your Brand — Fill Out the Form & We\'ll Respond Within 24 Hours →',
  'Eco-Friendly Custom Packaging — Explore Soot ink on request→',
  'Seed paper, Recycled paper, FSC certified paper for E-Commerce, D2C brands, Apparel, Events & More→',
  'Cotton Bags, Kraft Folders, Seed Paper Products & More — Explore Now →',
];

export default function AnnouncementBar() {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % announcements?.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="bg-primary text-white text-center py-2.5 px-4 text-sm font-medium overflow-hidden" style={{ fontFamily: 'DM Sans, sans-serif', letterSpacing: '0.02rem' }}>
      <div className="max-w-7xl mx-auto">
        <a
          href="#custom-packaging"
          className="hover:underline transition-all duration-200 inline-flex items-center gap-2"
        >
          <span key={currentIndex} className="animate-fade-in">
            {announcements?.[currentIndex]}
          </span>
        </a>
      </div>
    </div>
  );
}
